import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslations } from '../../../../shared/src/hooks/use-translations.hook';
import { AccordionItem } from './AccordionItem';
import './FAQ.css';
import { OffersDataService } from '../../../services/offers-data.service';

export const FAQ = () => {
    const { faqData } = OffersDataService.getOffersData();
    const { platformReady } = useSelector(state => state.app);
    const [activeItemId, setActiveItemId] = useState();
    const { t } = useTranslations();
    const faqTitle = platformReady && t('homeFAQ');

    const handleToggle = key => {
        setActiveItemId(activeItemId !== key ? key : null);
    };

    return (<section className="homepage-faq-container">
        <div className="homepage-faq-title">
            {faqTitle}
        </div>

        <div className="homepage-faq-items">
            {faqData.map(({ title, text }, index) =>
                <AccordionItem
                    key={index}
                    title={title}
                    text={text}
                    handleToggle={handleToggle}
                    isOpen={activeItemId === index}
                    index={index} />)}
        </div>
    </section>);
};
